import React from "react";

function Button({
  type = "solid", // 'solid' or 'outline'
  state = "enabled", // 'enabled' or 'disabled'
  icon, // Icon component (optional)
  label = "Button", // Button text (default)
  onClick,
  children,
  className, // Click handler
  ...props // Other props like className, etc.
}) {
  const isDisabled = state === "disabled";

  // Determine button styles based on type and state
  const baseStyles =
    "font-medium py-2 px-4 rounded-md focus:outline-none focus:ring-2 transition-all duration-300";
  const solidStyles =
    "bg-[#1f36c7] text-white hover:enabled:bg-blue-700 focus:ring-[#1f36c7] disabled:bg-blue-300 disabled:cursor-not-allowed rounded-md";
  const outlineStyles =
    "border border-[#1f36c7] text-[#1f36c7] bg-transparent hover:enabled:bg-[#1f36c7] hover:enabled:text-white focus:ring-[#1f36c7] disabled:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed rounded-md";
    const linkStyles =
    "text-[#1f36c7] bg-transparent border-none focus:ring-0 focus:outline-none disabled:text-gray-400 disabled:cursor-not-allowed p-0";

  const buttonStyles = 
    type === "solid" ? solidStyles : 
    type === "link" ? linkStyles :
    outlineStyles;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`${baseStyles} ${buttonStyles} flex  gap-2  justify-center items-center ${className}`}
      {...props}
    >
      {/* Icon (if provided) */}
      { icon}

      {/* Button Label */}
      {children}
    </button>
  );
}

export default Button;
